"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ScreenPresenterSource = exports.CameraPresenterSource = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../constants");
var _ImageFileSource = require("./ImageFileSource");
var _VideoFileSource = require("./VideoFileSource");
var _BannerSource = require("./BannerSource");
var _AudioFileSource = require("./AudioFileSource");
var _PdfFileSource = require("./PdfFileSource");
var _MediaSource = _interopRequireDefault(require("./MediaSource"));
var _ConnectedPresenterSource = require("./ConnectedPresenterSource");
var canShowMediaSource = function canShowMediaSource(props) {
  var _props$source = props.source,
    value = _props$source.value,
    isInitializing = _props$source.isInitializing,
    type = _props$source.type;

  // Display the grey colour placeholder if the source is unassigned or if
  // a presenter's screen share request has been accepted but the presenter hasn't started the screen share
  var isScreenSharePending = isInitializing && type === _constants.SCREEN_PRESENTER;
  return value === _constants.UNASSIGNED_SOURCE || isScreenSharePending;
};
var ScreenPresenterSource = exports.ScreenPresenterSource = function ScreenPresenterSource(props) {
  if (canShowMediaSource(props)) {
    return /*#__PURE__*/_react["default"].createElement(_MediaSource["default"], props);
  }
  return /*#__PURE__*/_react["default"].createElement(_ConnectedPresenterSource.ConnectedScreenPresenterSource, props);
};
var CameraPresenterSource = exports.CameraPresenterSource = function CameraPresenterSource(props) {
  if (canShowMediaSource(props)) {
    return /*#__PURE__*/_react["default"].createElement(_MediaSource["default"], props);
  }
  return /*#__PURE__*/_react["default"].createElement(_ConnectedPresenterSource.ConnectedCameraPresenterSource, props);
};
var _default = exports["default"] = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.CAMERA_PRESENTER, CameraPresenterSource), _constants.SCREEN_PRESENTER, ScreenPresenterSource), _constants.AUDIO_PRESENTER, function () {
  return null;
}), _constants.IMAGE_FILE, _ImageFileSource.ImageFileSource), _constants.PDF_FILE, _PdfFileSource.PdfFileSource), _constants.VIDEO_FILE, _VideoFileSource.VideoFileSource), _constants.BANNER, _BannerSource.BannerSource), _constants.AUDIO_FILE, _AudioFileSource.AudioFileSource), _constants.MEDIA, _MediaSource["default"]);